import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'signedPercentage',
  standalone: false
})
export class SignedPercentagePipe implements PipeTransform {
  transform(value: number | null | undefined): string {
    if (value == null) return '';
    const sign = value >= 0 ? '+' : '';
    return `${sign}${value.toFixed(2)}%`;
  }
}